import React, { Component } from "react";
import FormStyle from "../Element/FormStyle";
import bgimg from "./../../images/main-slider/slide6.jpg";
import logo from "./../../images/logo-color-2.png";

import bg1 from "./../../images/background/bg1.jpg";
import { setPageMeta } from "../../utils/pageMeta";
// import { Link } from 'react-router-dom';

class Contact extends Component {
    componentDidMount() {
        setPageMeta({
            title: "Kontakt – Rumours Media Sylt",
            description: "Kontaktiere Rumours Media auf Sylt für Social Media, Werbefilm und Immobilien-Marketing. Kostenloses Erstgespräch, Telefon +49 174 2110055.",
            path: "/contact",
        });
    }

    render() {
        return (
            <>
                {" "}
                <div className="page-content bg-white rubik">
                    <div className="home-banner home-banner-short bg-img-fix m-b80" style={{ backgroundImage: "url(" + bgimg + ")" }}>
                        <div className="home-bnr-inner">
                            <div className="home-bnr-content">
                                <h1 className="sr-only">Kontakt – Rumours Media Sylt</h1>
                                <img className="index-logo" src={logo} alt="Rumours Media Logo" />
                                <div className="home-bnr-btns"></div>
                            </div>
                        </div>
                    </div>

                    {/* <!-- contact area --> */}
                    <div className="content-block">
                        <div className=" bg-img-fix" style={{ backgroundImage: "url(" + bg1 + ")" }}>
                            <FormStyle />
                        </div>
                    </div>
                </div>
            </>
        );
    }
}
export default Contact;
